import CustomDialog from '../../../components/dialog/CustomDialog';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './StudentResetPassword.scss';

const defaultProps = {
  onClose: () => { },
  openDialog: false,
  backFunction: () => { },
};

const StudentResetPassword = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onClose, openDialog, backFunction } = mergedProps;
  return (
    <CustomDialog
      className='student-reset-password-dialog'
      openDialog={openDialog}
      onClose={onClose}
      title={(
        <div className='title'>
          It looks like you are a Student
        </div>
      )}
      content={(
        <div className='content'>
          <div className='message'>
            Please contact your Teacher to reset your password.
          </div>
        </div>
      )}
      actions={[
        {
          title: 'Not a student?',
          onClick: backFunction,
          className: 'btn-primary back-button',
        },
      ]}
      displayCloseIcon
    />
  );
};

export default StudentResetPassword;
